import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { ButtonWithIcon } from '@els/els-react--button';
import { Card } from '@els/els-react--card';

function DocumentAbstract({ abstractText, closeClick }) {
  const handleClose = () => {
    // Dispatch custom event for focus management
    const event = new CustomEvent('documentSectionClosed', {
      detail: {
        closedSection: 'abstractExpanded',
        focusNext: true,
      },
    });
    document.dispatchEvent(event);

    // Call the original close handler
    closeClick();
  };

  return (
    <Card
      data-section="abstractExpanded"
      id="abstractExpanded-content"
      tabIndex="-1"
      role="region"
      aria-labelledby="abstractExpanded-heading"
      className="result-detail-panel u-els-margin-top-1o2">
      <div className="result-detail-panel-wrapper u-els-display-flex">
        <h4 id="abstractExpanded-heading" className="u-els-margin-right-1o2 u-els-font-family-bold">
          Abstract:
        </h4>
        <div className="u-els-display-flex">
          <InnerHTML tag="p" className="u-els-font-size-base u-els-line-height-default u-els-margin-right-2x" html={abstractText} />
          <ButtonWithIcon
            data-e2e="abstract-button-close"
            type="link"
            iconOnly
            linkIconSize="s"
            linkOptions={['navigation']}
            sprite="Close"
            className="result-detail-panel-wrapper-close e2e-close"
            data-automationid="sub-menu-close"
            onClick={handleClose}>
            close
          </ButtonWithIcon>
        </div>
      </div>
    </Card>
  );
}

DocumentAbstract.propTypes = {
  abstractText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentAbstract;
